import { ModuleNameToModuleRegistry } from '../../types/types';
import { AutomaticInsightsBottomBar } from './components/AutomaticInsightsBottomBar';

const bottomBars: Readonly<ModuleNameToModuleRegistry> = Object.freeze({
  automatic_insights_bottom_bar_opt_in: AutomaticInsightsBottomBar,
});

export default bottomBars;
